import React from 'react'
import PropTypes from 'prop-types'

import { Icon, Text } from 'Components/UI'

import find from 'lodash/find'

import { PLATFORMS } from 'Constants/Platforms'

import { Container, IconHolder } from './styles'

const PLATFORMS_LABELS = [
  { title: 'Web', label: 'Web' },
  { title: 'iOS', label: 'iOS' },
  { title: 'Android', label: 'Android' },
  { title: 'Google Play', label: 'Android' },
  { title: 'App Store', label: 'iOS' },
  { title: 'PC', label: 'PC' },
]

function System({ platform }) {
  const logo = find(PLATFORMS, { title: platform?.platformName })
  const label = find(PLATFORMS_LABELS, { title: platform?.platformName })

  if (!label) return null

  return (
    <Container>
      <IconHolder>
        <Icon glyph={logo?.logo} />
      </IconHolder>
      <Text fontSize={[12, 12, 12, 14]} white>
        {label?.label}
      </Text>
    </Container>
  )
}

System.propTypes = {
  platform: PropTypes.object.isRequired,
}

export default System
